export const isFieldConfigurationConflict = (definition) => {
  return Boolean(definition && definition.ConfigurationConflict);
};

export const isSettingsChangeBlocked = (definitions, changes) => {
  const conflicts = new Set(Object.values(definitions || {}).filter(isFieldConfigurationConflict).map((row) => row.Name));
  return Object.keys(changes || {}).some((name) => conflicts.has(name));
};

export const fieldSettingsErrorMessage = (result) => {
  return result && result.code === 'FIELD_CONFIGURATION_CONFLICT'
    ? 'Field definitions conflict or have changed. Refresh Manage Fields and contact support before editing this field.'
    : 'Field settings could not be saved. Refresh Manage Fields before retrying.';
};
